<template>
    <div class="Vehicle" style="background-color:rgb(245,245,249);">
        <Gnb v-bind:gnbCode=gnbCode v-bind:loginInfo1=loginInfo1 v-bind:loginInfo2=loginInfo2 />
        <div style="width:100%;" class="d-flex flex-row "  >
            <Navs v-bind:navCode1=navCode1 v-bind:navCode2=navCode2 v-bind:NavList=NavList />
            <div class="mt-3" style="width:100%; background-color:rgb(245,245,249);">
                <PageCrumbs v-bind:pTitles=pTitles v-bind:pCrumbs=pCrumbs />
                <div class="content" style="width:100%;min-height:770px;padding:2px 15px; background-color:rgb(245,245,249);">
                   
                    <v-card elevation="1" class="mt-3 pa-5" >
                       <h3>Basic Info</h3>
                       <v-simple-table>
                           <tbody>
                           <tr>
                               <th class="listHeader tableLinerT" style="width:20%">National</th>
                               <td class="tableLinerT text-left pl-5" style="width:30%">
                                   <v-select style="font-size:13px;" class="align-self-center" v-model="selectCountryCode" :items="countryList" item-text="info" item-value="vals" label="Country" outlined dense single-line hide-details></v-select>
                               </td>
                               <th class="listHeader tableLinerT" style="width:20%">Factory</th>
                               <td class="tableLinerT text-left pl-5" style="width:30%">
                                   <div class="d-flex flat ">
                                        <v-select style="font-size:13px;" class="align-self-center" v-model="selectFactoryCode" :items="factoryList" item-text="info" item-value="vals" label="Factory" outlined dense single-line hide-details></v-select>
                                        <!--<v-btn icon class="pt-1"><v-icon>mdi-pencil</v-icon></v-btn>-->
                                    </div>
                               </td>
                           </tr>
                           <tr>
                               <th class="listHeader">Division</th>
                               <td class="text-left pl-5">
                                   <div class="d-flex flat ">
                                        <v-select style="font-size:13px;" class="align-self-center " v-model="selectDivision" :items="deivceClsList" item-text="info" item-value="vals" label="Division" @change="setModelInfo" outlined dense single-line hide-details></v-select>
                                        <!--<v-btn icon class="pt-1"><v-icon>mdi-pencil</v-icon></v-btn>-->
                                    </div>
                               </td>
                               <th class="listHeader" >Model </th>
                               <td class="text-left pl-5">
                                   <div class="d-flex flat ">
                                        <v-select style="font-size:13px;" class="align-self-center" v-model="selectModelNum" :items="modelList" item-text="info" item-value="vals" label="Model" outlined dense single-line hide-details></v-select>
                                        <!--<v-btn icon class="pt-1"><v-icon>mdi-pencil</v-icon></v-btn>-->
                                    </div>
                               </td>
                           </tr>
                           <tr>
                               <th class="listHeader">ID</th>
                               <td class="text-left pl-5">
                                   <v-text-field v-model="dvcID" outlined dense single-line hide-details small placeholder="ID"></v-text-field>
                               </td>
                               <th class="listHeader">Software</th>
                               <td class="text-left pl-5">
                                   <v-text-field v-model="dvcSW" outlined dense single-line hide-details small placeholder="Software"></v-text-field>
                               </td>
                           </tr>                           
                           <tr>
                               <th class="listHeader">Registered User</th>
                               <td class="text-left pl-5">
                                   <!--
                                    <v-select style="font-size:13px;" class="align-self-center" v-model="selectInsUsr" :items="managerList" item-text="info" item-value="vals" label="Manage User" outlined dense single-line hide-details></v-select>
                                    -->
                                    <MngSelect2 @mngID2="mngListUpt2"/>
                               </td>
                               <th class="listHeader">Approval User</th>
                               <td class="text-left pl-5">
                                   <!--
                                    <v-select style="font-size:13px;" class="align-self-center" v-model="selectAprvUsr" :items="managerList" item-text="info" item-value="vals" label="Manage User" outlined dense single-line hide-details></v-select>
                                    -->
                                    <MngSelect @mngID="mngListUpt"/>
                               </td>
                           </tr>
                           <tr>
                               <th class="listHeader">Status</th>
                               <td class="tableLinerB text-left pl-5">
                                   <v-select style="font-size:13px;" class="align-self-center" v-model="selectAprvStatus" :items="approvalList" item-text="info" item-value="vals" label="Status" outlined dense single-line hide-details></v-select>
                               </td>
                               <th class="listHeader tableLinerB">Registration Date</th>
                               <td class="tableLinerB text-left pl-5">
                                   <v-text-field v-model="today" outlined dense single-line hide-details small readonly ></v-text-field>
                               </td>
                           </tr>
                           </tbody>
                       </v-simple-table>
                    
                        <div class="d-flex justify-space-between dense pa-0 mt-5" >
                            <div class="pa2 " >
                                <v-btn dark class="backBtn px-5" @click="goBack" >Cancel</v-btn>
                            </div>
                            
                            <div class="pa2 ">
                                <v-btn dark class="registerBtn ml-2 px-6" @click="chkDvcID">Save</v-btn>
                            </div>
                        </div>
                    </v-card>
                </div>
            </div>
        </div>
        <Footer/>

       <!-- Alert Dialog / Save -->
        <div class="text-center pb-0 mb-0" >
            <v-dialog v-model="alertFlag" width="450">
                <v-card>
                    <v-card-title class="text-subtitle-2 pb-0 text-wrap d-flex flat" style="width:450px;">
                        <v-icon class='d-flex' style='color:red;'>mdi-alert </v-icon>
                        <span class="d-flex pl-3">{{alertText}}</span>
                    </v-card-title>
                    <v-card-actions class="justify-end">
                        <v-btn color="primary" text @click="alertFlag = false;regFlag='Y'">ok</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </div>

        <!--asyncSuccess-->
        <div class="text-center pb-0 mb-0" >
            <v-dialog v-model="asyncSuccess" width="400">
                <v-card>
                    <v-card-title class="text-subtitle-1 pb-0">
                        <v-icon style='color:green;'>mdi-check-circle </v-icon>
                        <span class="pl-3">It's been processed successfully</span>
                    </v-card-title>
                    <v-card-actions class="justify-end">
                        <v-btn color="primary" text @click="goList">ok</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </div>

        <!--asyncErrors-->
        <div class="text-center pb-0 mb-0" >
            <v-dialog v-model="asyncErrors" width="400">
                <v-card>
                    <v-card-title class="text-subtitle-1 pb-0">
                        <v-icon style='color:green;'>mdi-alert-circle </v-icon>
                        <span class="pl-3">It's been processed failed.</span>
                    </v-card-title>
                    <v-card-actions class="justify-end">
                        <v-btn color="primary" text @click="asyncErrors=false;">ok</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </div>      

      
    </div>
</template>

<style scoped>
    th {height:38px;}
    .rowList { padding:5px 0;}
    .tableLinerR {border-right:1px solid rgb(0, 0, 0, 0.12)}
    .tableLinerB {border-bottom:1px solid rgb(0, 0, 0, 0.12)}
    .tableLinerT {border-top:1px solid rgb(0, 0, 0, 0.12)}
    tbody tr:hover { background-color: transparent !important; }
</style>

<script>
import Gnb from '@/components/gnbComponent.vue'
import PageCrumbs from '@/components/pageCrumbs.vue'
import Footer from '@/components/footerComponent.vue'
import Navs from '@/components/nav.vue'
import MngSelect from '@/components/cfgManager.vue'
import MngSelect2 from '@/components/cfgManager2.vue'

export default {
    name: 'DeviceWrite',
    components: { Gnb, Footer, PageCrumbs,  Navs, MngSelect, MngSelect2},
    data () {
        return {
             // login Info
            gnbCode:"2", loginInfo1: "", loginInfo2: "", loginInfo3: "",
            navCode1:1, navCode2:12, 
            // Page Title & Breadcrumbs
            pTitles: "New Registration",
            pCrumbs: [ { text: 'Home', disabled: true,}, { text: 'Device', disabled: true,}, { text: 'Device Management', disabled: true,}, { text: 'New Registration', disabled: false,}],

            NavList: [ 
                        { title: 'Device Management', nums: '1',
                            items: [ { title: 'Device List', nums:11, href:'/Device', icons:'mdi-format-list-bulleted' },{ title: 'New Registration', nums:12, href:'/DeviceWrite', icons:'mdi-lead-pencil' },],
                        },
                    ],     
            
            continentCode: "1", 
            
            dvcID: "", dvcSW: "",
            regDate: "",

            selectCountryCode:"", selectFactoryCode:"", selectDivision:"", selectModelNum:"", selectAprvStatus:"", 
            selectInsUsr:"", selectAprvUsr:"",
            
            today: new Date().toISOString().substr(0, 10),

            countryList:[{info: 'Indonesia', vals: "ID"}, {info: 'korea', vals: "KR"}], 
            factoryList: [{info: '현대캐피코', vals: 4}, {info: 'LG에너지솔루션', vals: 5}, {info: '풍산시스템', vals: 6}, {info: '보다폰', vals: 7}],
            modelList: [{info:'none', vals:"0"}], 
            deivceClsList: [{info: 'VCU', vals: 1}, {info: 'MCU', vals: 2}, {info: 'BMS', vals: 3}, {info: 'Charger', vals: 4}],
            managerList:[{info:'admin', vals:'admin'},{info:'manager', vals:'manager'}],
            //approvalList: [{info: 'Incoming', vals: 1}, {info: 'Repair', vals: 2}, {info: 'Reception', vals: 3}, {info: 'Disapproval', vals: 4}, {info: 'Ready', vals: 5}, {info: 'Approval', vals: 6} ],
            approvalList: [{info: 'Disapproval', vals: 4},  {info: 'Approval', vals: 6} ],

            regFlag:'Y', alertFlag:false, alertText:'', 
            asyncErrors: false, asyncSuccess: false, asyncActType: "C",

            editFlag: false,
            editEbkSeq:'',
            formValid:false,
        }
    },

    beforeCreate() {
        let uuid = localStorage.getItem("e3MngID");
        let uauthcode = localStorage.getItem("e3MngCode"); 
        if(uuid != '' && uauthcode !='') {
            var  requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ "uid": uuid, "authCode": uauthcode})
            };
            fetch('https://api.e3bss.com/_APP/POC/validAuthUsr.php', requestOptions)
            .then((response) => {
                if(response.ok) {
                    return response.json();
                }
                throw new Error('Network response was not ok');
            })
            .then((json) => {
                if(json.result != "success") {
                    this.$router.replace('RequireLogin');
                } 
            }).catch(() => {
                //console.log(error);
                this.$router.replace('Error');
            });
        } else {
             this.$router.replace('RequireLogin');
        }
    },

    created() {
        this.loginInfo1=localStorage.getItem("e3MngID");
        this.loginInfo2=localStorage.getItem("e3MnglgDTM");
        this.loginInfo3=localStorage.getItem("e3MngCode");
        //console.log('param 확인' + this.$route.params.Seq +" / "+ this.$route.params.Cls);
        this.schSeq = this.$route.params.Seq; 
        this.schCls = this.$route.params.Cls;
        if(this.schSeq != '' && this.$route.params.Seq != undefined && this.schCls != '' && this.$route.params.Cls != undefined) {
            this.navCode2=11;
            this.pTitles = "Edit";
            this.pCrumbs = [ { text: 'Home', disabled: true,}, { text: 'Device', disabled: true,},  { text: 'Device Management', disabled: true,}, { text: 'Device List', disabled: true,}, { text: 'Edit', disabled: false,}];

            this.getInfo();
            this.getHistory();
        } else {
            this.pTitles = "New Registration";
            this.pCrumbs = [ { text: 'Home', disabled: true,}, { text: 'Device', disabled: true,},  { text: 'Device Management', disabled: true,}, { text: 'New Registration', disabled: false,}];
        }
        window.scrollTo(0, 0);

    },

    methods : {

        setModelInfo() {
            if(this.selectDivision == "1" ) {   // vcu
                this.modelList = [{info:'none', vals:"-"}]; 
            } else if(this.selectDivision == "2") { // mcu
                 this.modelList = [{info:'none', vals:"-"}]; 
            } else if(this.selectDivision == "3") { // bms
                 this.modelList = [{info:'none', vals:"-"}]; 
            } else if(this.selectDivision == "4") { // charger
                 this.modelList = [{info:'PS EMBC-D01', vals:"PS EMBC-D01"}]; 
            } else  {
                 this.modelList = [{info:'none', vals:"-"}]; 
            }
            
        },

        mngListUpt(arg){
            this.selectAprvUsr = arg;
            //console.log("selectAprvUsr="+this.selectAprvUsr);
        },    

        mngListUpt2(arg){
            this.selectInsUsr = arg;
            //console.log("selectInsUsr="+this.selectInsUsr);
        },  

        // API Async 
        getInfo() {
            var  requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ "usrID": this.loginInfo1
                    , "authCode": this.loginInfo3
                    , "act": "R"
                    , "schDvcSeq": this.schSeq
                    , "schDvcClass": this.schCls
                })
            };

            var apiURL = "https://api.e3bss.com/_APP/POC/dvcInfo.php"; 
                        
            fetch(apiURL, requestOptions)
            .then((response) => {
                if(response.ok) {
                    return response.json();
                }
                throw new Error('Network response was not ok');
            }).then((json) => {
                //console.log(json);
                if(json.result == "success") {
                    this.editFlag=true;
                    this.asyncActType="U";

                    this.DVC_CLASS = json.DVC_CLASS; this.DVC_SEQ = json.DVC_SEQ; this.selectModelNum = json.DVC_MODEL; 
                    this.dvcSW = json.DVC_SW; 
                    this.dvcID = json.DVC_ID; 
                    this.selectCountryCode = json.COUNTRY_CODE; this.NAT_NAME_KR = json.NAT_NAME_KR; 
                    this.selectFactoryCode = Number(json.FACTORY_CODE); this.FAC_NAME_KR = json.FAC_NAME_KR; 
                    this.selectDivision = Number(json.DVC_DIVISION);

                    this.selectAprvStatus = Number(json.APRV_STATUS); this.APRV_INFO = json.APRV_INFO;
                    this.selectAprvUsr = json.APRV_USR_ID; this.APRV_USR = json.APRV_USR; this.APRV_DTM = json.APRV_DTM;

                    this.INS_DTM = json.INS_DTM.substr(0,10); this.selectInsUsr = json.INS_USR_ID; this.INS_USR = json.INS_USR;

                    this.today = this.INS_DTM;
                    
                    this.emptyFlag = false;

                } else {
                   
                    this.emptyFlag = true;
                    
                }
            }).catch(() => {
                //console.log(error);
                this.$router.replace('Error');
            });
        },
        
        regOpenHistory() {
            this.histroyCont = "";
            this.historyRegFlag = true;
        },

        getHistory() {
            var  requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ "usrID": this.loginInfo1
                    , "authCode": this.loginInfo3
                    , "act": "L"
                    , "dvcSeq": this.schSeq
                    , "dvcType": this.schCls
                })
            };
            
            fetch('https://api.e3bss.com/_APP/POC/shareHistory.php', requestOptions)
            .then((response) => {
                if(response.ok) {
                    return response.json();
                }
                throw new Error('Network response was not ok');
            }).then((json) => {
                //console.log(json.result );
                if(json.result == "success") {
                    this.historyList = json.list;
              
                    this.emptyHistoryFlag = false;
                } else {
                   this.historyList = [];
                    this.emptyHistoryFlag = true;
                    
                }
            }).catch(() => {
                //console.log(error);
                this.$router.replace('Error');
            });
        },

        addHistory() {
            this.validate();
            if( this.histroyCont == "" || this.histroyCont < 10 || this.histroyCont.length > 100 ) {
                alert('Please enter more than 10 characters and less than 100 characters');
                this.formValid = false;
            }
            
            //console.log(this.formValid);
            
            if(this.formValid === true) {
                var requestOptions = {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ "usrID": this.loginInfo1
                        , "authCode": this.loginInfo3
                        , "act": "C"
                        , "dvcSeq": this.schEbkSeq
                        , "cont": this.histroyCont
                        , "dvcType": 5
                    })
                };
                
                fetch('https://api.e3bss.com/_APP/POC/shareHistory.php', requestOptions)
                .then((response) => {
                    if(response.ok) {
                        return response.json();
                    }
                    throw new Error('Network response was not ok');
                }).then((json) => {
                    //console.log(json.result );
                    if(json.result == "success") {
                        this.getHistory();
                        this.histroyCont = '';
                        this.historyRegFlag = false;
                    } 
                }).catch(() => {
                    //console.log(error);
                    this.$router.replace('Error');
                });
            } else {
                this.resetValidation();
            }
            
        },
        
        validate () {
            //alert('a');
            this.$refs.form.validate();
        },
        
        resetValidation () {
            //alert('b');
            this.$refs.form.resetValidation();
        },
        
        closeHistoryDialog() {
            this.histroyCont = "";
            this.historyRegFlag = false;
        },

        // temp : child Error Component
        closeErrorDialog() {
            this.histroyCont = "";
            this.asyncErrors = false;
        },

        // back button
        goBack() {
            //console.log('back');
            //return this.$router.go(-1);
            this.$router.push({ name: 'Device'});
        },

        chkDvcID() {
            if(this.dvcID == '') {
                this.alertToForm('1', 'ID');
                this.regFlag='N'; this.alertFlag=true;
                return;
            } else {
                if( this.asyncActType != "U") {
                    var requestOptions2 = {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ "dvcID": this.dvcID, "dvcClass": this.selectDivision })
                    };
                    //console.log(JSON.stringify({ "dvcID": this.dvcID, "dvcClass": this.selectDivision }));
                    fetch("https://api.e3bss.com/_APP/POC/chkDvcID.php", requestOptions2)
                    .then((response) => {
                        if(response.ok) {
                        return response.json();
                        }
                        throw new Error('Network response was not ok');
                    }).then((json) => {
                        //console.log("chkDvcID="+JSON.stringify(json));
                    
                        if(json.result == "success") {
                            this.alertFlag=false;
                            this.regInfo();
                        } else {
                            this.regFlag='N';
                        
                            this.alertToForm('99', 'Device ID must be unique.');
                            this.alertFlag=true;
                            return;
                        }  
                    }).catch(() => {
                        this.asyncErrors = true;
                        //console.log(error);
                    });
                } else {
                    this.alertFlag=false;
                    this.regInfo();
                }
            }
        },

        regInfo() {
            
            if(this.selectCountryCode == '') {
                this.regFlag='N'; this.alertFlag=true;
                this.alertToForm('2', 'National');
                return;
            }
            if(this.selectFactoryCode == '') {
                this.regFlag='N'; this.alertFlag=true;
                this.alertToForm('2', 'Factory');
                return;
            }
            /*
            if(this.selectModelNum == '') {
                this.regFlag='N'; this.alertFlag=true;
                this.alertToForm('2', 'Vehicle Model');
                return;
            }
            */
            
            //if(this.dvcID == '') {
            //    this.regFlag='N'; this.alertFlag=true;
            //    this.alertToForm('1', 'ID');
            //    return;
           // }
            
            if(this.selectInsUsr == '') {
                this.regFlag='N'; this.alertFlag=true;
                this.alertToForm('2', 'Registered User');
                return;
            }
            if(this.selectAprvUsr == '') {
                this.regFlag='N'; this.alertFlag=true;
                this.alertToForm('2', 'Approval User');
                return;
            }
            if(this.selectAprvStatus == '') {
                this.regFlag='N'; this.alertFlag=true;
                this.alertToForm('2', 'Status');
                return;
            }
            
            var cellStatus = 1;
            var param =JSON.stringify({ "usrID": this.loginInfo1
                , "authCode": this.loginInfo3
                , "act": this.asyncActType
                , "countryCode": this.selectCountryCode, "factoryCode": this.selectFactoryCode
                , "modelNum": this.selectModelNum, "idtfyNums": this.idtfyNums
                , "insUsr": this.selectInsUsr, "aprvUsr": this.selectAprvUsr
                , "aprvStatus": this.selectAprvStatus, "regDate": this.today
                , "cellID": this.dvcID, "swInfo": this.dvcSW
                , "cellStatus": cellStatus
                , "cellSeq": this.schSeq
                
            });
            //console.log("param="+param);
            var  requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: param
            };

            var apiURL = ""; 
            if(this.selectDivision == 1) {
                apiURL = "dvcVcu";
            } else if(this.selectDivision == 2) {
                apiURL = "dvcMcu";
            } else if(this.selectDivision == 3) {
                apiURL = "dvcCell";
            } else if(this.selectDivision == 4) {
                apiURL = "dvcCharger";
            } 
            //console.log("apiURL="+apiURL);
            fetch("https://api.e3bss.com/_APP/POC/"+apiURL+".php", requestOptions)
            .then((response) => {
                if(response.ok) {
                    return response.json();
                }
                throw new Error('Network response was not ok');
            }).then((json) => {
                //console.log(json);
                
                if(json.result == "success") {
                    this.asyncSuccess=true;
                } else {
                    this.asyncErrors = true;
                }  
            }).catch(() => {
                this.asyncErrors = true;
                //console.log(error);
            });
            
        },
        
        alertToForm(arg1, arg2) {
            if(arg1 != "99") {
                var str1 = "enter";
            var strInfo1 = "Please"; var strInfo2 = "information";
            if(arg1 == "2") str1 = 'select';
                this.alertText = strInfo1 +' '+ str1 +' '+ arg2 +' '+ strInfo2+".";
            } else {
                this.alertText = arg2;
            }
            
            // Please select country information 
        },

        goList(){
            this.asyncSuccess=false;
            this.$router.push("Device");
        }
    },
    

}
</script>
